<div id="comparatoreMFPanels" class="panels-container">

    <div class="row">

        @if (isShowSidePanel) {
            <div class="col-sm-3 panel-col side-panel">
                <app-side-panel></app-side-panel>
            </div>
        }

        <div class="col-sm-{{isShowSidePanel ? '9' : '12'}} panel-col panels-content">
            @if (isShowBanners) { <app-banner></app-banner> }
            <ng-content></ng-content>
        </div>

    </div>

</div>